module.exports = __webpack_public_path__ + "img/icon-04.16d6e704.svg";